const lindaGirlVideoThumbnailsContainer = document.getElementById('linda-girl-video-thumbnails');
const lindaGirlVideoThumbnails = Array.from(document.getElementsByClassName('linda-girl-video-thumbnail'));
const lindaGirlVideoContainer = document.getElementById('linda-girl-video-element');

lindaGirlVideoThumbnails.forEach((element) => {
  const videoHTML = element.dataset.videoElement;

  element.addEventListener('click', (event) => {
    event.preventDefault();
    const currentActive = lindaGirlVideoThumbnailsContainer.querySelector('.active');
    if (currentActive) {
      currentActive.classList.remove('active');
    }

    element.parentNode.classList.add('active');
    lindaGirlVideoContainer.innerHTML = videoHTML;
  });
});
